import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import marketingManagementAPI from '../apis/marketingManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class MarketingManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable isGroupFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []
  @observable groupLogData = []
  @observable groupLogTotal = 0
  @observable groupLogPageSize = PAGE_SIZE_DEFAULT
  @observable groupLogPageNo = 1

  /*SearchResult start*/
  @observable searchItem = {
    'groupName': '',
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await marketingManagementAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @observable auditLogsUserList = []
  @action
  async getAuditUsers() {
    this.auditLogsUserList = []
    try {
      const response = await marketingManagementAPI.getAuditUsers()
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.auditLogsUserList = data.map(a=>{return {
            ...a,
            "email": a?.email,
            "phone": a?.phone,
            "userId": a?.id,
            "userName": a?.shortName
          }})
        } else {
          alertMessage.error('获取失败' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  @observable groupList = []
  @action
  async onGetGroup(params) {
    this.groupList = []
    try {
      const response = await marketingManagementAPI.getGroup(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.groupList = data
        } else {
          alertMessage.error('获取失败' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  /*add*/
  @action
  async onAddJobAction(params, title) {
    this.isFetching = true
    try {
      const response = await marketingManagementAPI.addAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data?.code === 0) {
          alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
        }
      })
      return response
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit*/
  @observable detailsObj = null

  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await marketingManagementAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }


  /*status*/
  @action
  async onChangeStatus(apiID) {
    this.isFetching = true
    try {
      const response = await marketingManagementAPI.statusAction(apiID)
      runInAction(() => {
        this.isFetching = false
        // if (response.data.code === 200) {
        if (response.data.code === 0) {
          alertMessage.success('获取成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('获取失败！' + response.data.data + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await marketingManagementAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'groupName': this.searchItem.groupName,
      'isPowerUser': this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }

  @action
  async groupLogSave(params) {
    this.isGroupFetching = true
    try {
      const response = await marketingManagementAPI.groupLogSave(params)
      runInAction(() => {
        this.isGroupFetching = false
        if (response.data.code === 0) {
          alertMessage.success('保存成功！')
          this.onSearchJobAction(this.searchItem)
        } else {
          alertMessage.error('保存失败！' + response.data.message + '')
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isGroupFetching = false
      })
    }
  }

  @action
  async groupLogList(params) {
    this.isGroupFetching = true
    try {
      const response = await marketingManagementAPI.groupLogList(params)
      runInAction(() => {
        this.isGroupFetching = false
        if (response.data.code === 0) {
          this.groupLogTotal = response.data.data.total
          this.groupLogData = response.data.data.records
        } else {
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isGroupFetching = false
      })
    }
  }

  @action
  async groupLogPageNumAction(pageNo, pageSize, params) {
    if (this.groupLogPageNo === pageNo && (!pageSize || this.groupLogPageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.groupLogPageNo = pageNo
      this.groupLogPageSize = pageSize
    })
    this.groupLogList({
      ...params,
      'page': pageNo,
      'size': pageSize,
    }).then()
  }
}
